<!--
 * @Author: zhangxiaowei 229465267@qq.com
 * @Date: 2024-05-27 18:17:26
 * @LastEditors: zhangxiaowei 229465267@qq.com
 * @LastEditTime: 2024-05-28 15:36:52
 * @FilePath: /lowCode/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <router-view />
</template>

<script setup lang="ts"></script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  background-image: linear-gradient(120deg, #18181c 0%, #18181c 100%);
}
</style>
